"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "28", viewBox: "0 0 38 28", className: "Icon element-card", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#888", d: "M0 0h38v28H0z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h36v26H1z" }),
            _react2.default.createElement("path", { d: "M38 0v28H0V0h38zM1 1v26h36V1H1z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "#929292", d: "M6 7h26v1H6zM6 10h24v1H6zM6 13h26v1H6zM6 16h22v1H6z" }),
            _react2.default.createElement("path", { fill: "#929292", d: "M6 7h26v1H6zM6 10h24v1H6zM6 13h26v1H6zM6 16h22v1H6z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-card.js
// module id = 1794
// module chunks = 0